import React from 'react'

import {AddressEncoder} from 'ui'
import {Input, Select} from 'forms'

export const Definition = ({network, device}) => (
   <div>
      <dl className="dl-horizontal dl-form">
         <dt>Key</dt>
         <dd>{network.key}/{device.key}</dd>

         <dt>Address</dt>
         <dd><AddressEncoder value={device.address} /></dd>

         <dt>Name</dt>
         <dd>
            <Input.Toggleable param="name" value={device.name || ''}>
               Unnamed Device
            </Input.Toggleable>
         </dd>

         <dt>Type</dt>
         <dd>
            <Select param="type" options={network.types} />
         </dd>

         <dt>Provision</dt>
         <dd>
            <Select param="provisioned" options={['active', 'passive', 'inactive']} />
         </dd>
      </dl>
   </div>
)

Definition.propTypes = {
   network: React.PropTypes.object.isRequired,
   device:  React.PropTypes.object.isRequired
}



// WEBPACK FOOTER //
// lib/bundle/dashboard/device/overview/Definition.jsx